import { ChainId } from 'constant';
import { action, computed, makeAutoObservable } from 'mobx';

import user from './user';
interface CapsuleContract {
    [ChainId.mainnet]?: {
        abi: string;
        address: string;
    };
    [ChainId.testnet]?: {
        abi: string;
        address: string;
    };
}

export class Contracts {
    capsuleContract: CapsuleContract = {
        [ChainId.mainnet]: undefined,
        [ChainId.testnet]: undefined,
    };
    constructor() {
        makeAutoObservable<this>(this);
    }

    @computed get capsule() {
        return this.capsuleContract[user.chainId];
    }

    setCapsuleContract(address: string, abi: string) {
        this.capsuleContract[user.chainId] = {
            abi,
            address,
        };
    }
}

export default new Contracts();
